import React from 'react'
import Techblogimage from "./techblog.png"

export default function Techblog() {
  return (
    <img className ="w-64 m-auto rounded-lg hover:w-96 hover:ease-in duration-300" src={Techblogimage}></img>
  )
}
